import { useState, useEffect } from "react";
import db from "./Firebase";

// Returns live list of category names saved from the SubProducts page.
// Usage: const { categories, loading } = useCategories();
const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = db
      .collection("product_categories")
      .orderBy("name")
      .onSnapshot(
        (snap) => {
          setCategories(snap.docs.map((d) => ({ id: d.id, name: d.data().name })));
          setLoading(false);
        },
        (err) => {
          console.error("Error fetching categories: ", err);
          setLoading(false);
        }
      );
    return () => unsubscribe();
  }, []);

  return { categories, loading };
};

export default useCategories;